import { ExternalLink } from "./ExternalLink";
import { PageIntro } from "./PageIntro";

const taitungTourism = "https://tour.taitung.gov.tw/zh-tw/traffic/taitung";

export function GettingToTaitungPage() {
  return (
    <div className="standard-page getting-taitung-page">
      <PageIntro
        eyebrow="FIRST STOP"
        title="如何到台東"
        en="GETTING TO TAITUNG"
      >
        <p>先選擇最適合你的方式抵達台東，再從市區前往都蘭小星。</p>
      </PageIntro>

      <section className="taitung-map-section">
        <figure className="taitung-route-figure">
          <img
            src="/images/taitung-traffic.svg"
            alt="台北、台中、花蓮與高雄前往台東的交通時間與距離示意"
          />
          <figcaption>台灣主要城市前往台東方位示意</figcaption>
        </figure>
        <div className="taitung-map-intro">
          <p className="eyebrow">CHOOSE YOUR WAY</p>
          <h2>旅程從抵達台東開始</h2>
          <p>
            台東沒有高鐵，最常見的方式是搭臺鐵、從台北搭飛機，或自行開車。圖中時間為旅程規劃用約略值，實際時間請以交通單位公告為準。
          </p>
          <a className="outline-dark" href="/direction">
            已抵達台東？前往小星 →
          </a>
        </div>
      </section>

      <section className="arrival-methods" aria-label="前往台東的交通方式">
        <article>
          <header>
            <span>01</span>
            <p className="eyebrow">BY TRAIN</p>
            <h2>搭臺鐵</h2>
          </header>
          <div className="arrival-method-content">
            <p>
              抵達台東火車站後，可轉乘公車或計程車前往都蘭。<br/>After arriving at
              Taitung Station, continue to Dulan by bus or taxi.
            </p>
            <div>
              <ExternalLink
                className="text-link"
                href="https://tip.railway.gov.tw/tra-tip-web/tip"
              >
                臺鐵時刻查詢 Train schedules ↗
              </ExternalLink>
              <ExternalLink
                className="text-link"
                href="https://tip.railway.gov.tw/tra-tip-web/tip/tip001/tip121/query"
              >
                臺鐵網路訂票 Book train tickets ↗
              </ExternalLink>
            </div>
          </div>
        </article>

        <article>
          <header>
            <span>02</span>
            <p className="eyebrow">BY AIR</p>
            <h2>搭飛機</h2>
          </header>
          <div className="arrival-method-content">
            <p>
              台北松山機場往返台東航空站，飛行時間約 1
              小時。抵達機場後，可搭計程車或先前往市區轉乘。<br/>Flights between
              Taipei Songshan and Taitung take about one hour. From Taitung
              Airport, take a taxi or travel into the city to transfer.
            </p>
            <ExternalLink className="text-link" href="https://www.tta.gov.tw/">
              台東航空站 Taitung Airport ↗
            </ExternalLink>
          </div>
        </article>

        <article>
          <header>
            <span>03</span>
            <p className="eyebrow">BY CAR</p>
            <h2>自行開車</h2>
          </header>
          <div className="arrival-method-content">
            <p>
              從北部可經花蓮沿台 9 或台 11
              線南下；從南部可經屏東楓港走南迴公路。山區與海岸路況受天候影響，出發前請確認即時路況。
              <br/>From the north, drive south from Hualien on Highway 9 or 11. From
              the south, take the South Link Highway via Fanggang. Check road
              and weather conditions before setting out.
            </p>
            <ExternalLink className="text-link" href="https://168.thb.gov.tw/">
              公路即時路況 Live road conditions ↗
            </ExternalLink>
          </div>
        </article>

        <article>
          <header>
            <span>04</span>
            <p className="eyebrow">BY COACH</p>
            <h2>長途客運</h2>
          </header>
          <div className="arrival-method-content">
            <p>
              花蓮與台東之間有行駛台 11
              線的海線客運，適合想沿途欣賞東海岸或從花蓮接續旅程的旅客。<br/>Coastal
              coaches run between Hualien and Taitung along Highway 11—a scenic
              option for travellers continuing from Hualien.
            </p>
            <ExternalLink
              className="text-link"
              href="https://www.taiwanbus.tw/eBUSPage/Default.aspx?lan=C"
            >
              公路客運即時動態 Coach information ↗
            </ExternalLink>
          </div>
        </article>
      </section>

      <section className="arrival-source-note">
        <p>
          交通時間可能因車種、班次、日期與路況不同；購票前請以營運單位公告為準。
        </p>
        <ExternalLink className="text-link" href={taitungTourism}>
          參考：台東觀光旅遊網「如何到台東」↗
        </ExternalLink>
      </section>
    </div>
  );
}
